import styled from 'styled-components'

export default styled.article`
  width: 100%;
  min-height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${ ({ theme }) => theme.colors.almostWhite };

  &.landing {
    scroll-behavior: smooth;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @media (prefers-reduced-motion: reduce) {
      scroll-behavior: auto;
    }
  }

  button.floating-button {
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 20px;
    width: max-content;
    padding: 0 20px;
    z-index: 2;

    &.nemi,
    &.iframe {
      position: relative;
      margin: auto;
      margin: 0;
    }
  }

  &.authenticated:not(.iframe) {
    height: calc(100% - 80px) !important;

    &.nemi,
    &.iframe {
      height: auto !important;
    }
    
    .spinner-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`
